module.exports = __webpack_public_path__ + "static/media/medall-alt.47042660.svg";